import { type FileItem } from '../../models/files';

export function getThumbnailUrl(item: FileItem): string | undefined {
  if (!item.thumbnailUrl && !item.cropData) {
    return undefined;
  }

  return item.thumbnailUrl || item.cropData?.objectUrl || undefined;
}
